import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'no',
    fullName: 'Norwegian',
    nativeName: 'Norsk',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Noe utrolig kommer",
    landing_subtitle: "ArgVoid er et app- og spillutviklingsstudio. Følg med, nye ting kommer snart!",
    select_language: "Velg Språk",
    search_placeholder: "Søk etter språk...",
    terms_title: "Vilkår for bruk",
    policy_title: "Personvernerklæring",
    cookies_title: "Retningslinjer for informasjonskapsler",
    terms_content: `
        <strong>1. Aksept av vilkår</strong><br>
        Ved å gå inn på ArgVoid godtas disse vilkårene for bruk. Hvis disse vilkårene ikke godtas, skal ikke tjenesten brukes.<br><br>

        <strong>2. Plattformbruk</strong><br>
        ArgVoid og dets applikasjoner leveres "som de er" for informasjons- og kreative formål. Tjenesten må kun brukes til lovlige formål.<br><br>

        <strong>3. Forbudt oppførsel</strong><br>
        Utnyttelse av sårbarheter på nettstedet, spamming eller forsøk på uautorisert tilgang til infrastrukturen er strengt forbudt.<br><br>

        <strong>4. Ansvarsfraskrivelse</strong><br>
        Plattformen og tjenestene kan endres når som helst uten varsel. Det gis ingen garanti angående oppetid eller tilgjengelighet av tjenesten.
    `,
    policy_content: `
        <strong>1. Informasjonssamling</strong><br>
        Plattformen krever ikke brukerautentisering eller kontooppretting på dette tidspunktet. Ingen personlig identifiserende informasjon (som navn eller e-postadresser) samles aktivt inn fra besøkende.<br><br>

        <strong>2. Bruk Data</strong><br>
        Grunnleggende, anonymiserte analyser kan samles inn for å forstå trafikken på nettstedet og forbedre applikasjonene. Disse dataene er ikke knyttet til individuelle brukeridentiteter.<br><br>

        <strong>3. Tredjepartstjenester</strong><br>
        Tredjepartsleverandører kan brukes for hosting og analysetjenester. Personvernpraksisen til disse respektive leverandørene styrer de anonyme dataene som behandles på deres infrastruktur.<br><br>

        <strong>4. Datasikkerhet</strong><br>
        Rimelige sikkerhetstiltak er iverksatt for å beskytte plattformen. Imidlertid er ingen metode for overføring over Internett helt sikker.<br><br>
    `,
    cookies_content: `
        <strong>1. Hva er informasjonskapsler og lokal lagring?</strong><br>
        Informasjonskapsler og lokal nettleserlagring er små datafiler som er lagret på enheten for å huske konfigurasjonspreferanser på tvers av besøk.<br><br>

        <strong>2. Bruksformål</strong><br>
        Nettleser LocalStorage brukes kun for å lagre konfigurasjonsinnstillinger, for eksempel: <br>
        - Språkpreferanser<br>
        - Brukergrensesnittkonfigurasjon (f.eks. layout eller temainnstillinger) <br>
        - Midlertidig applikasjonscache<br><br>

        <strong>3. Ingen sporing</strong><br>
        Informasjonskapsler og lokal lagring brukes ikke til reklame- eller tredjepartsformål. Alle lagrede data er strengt tatt for kjernefunksjonaliteten til plattformen.<br><br>

        <strong>4. Kontroll</strong><br>
        Nettleserdata kan slettes når som helst gjennom nettleserinnstillingene, som vil tilbakestille alle lokale konfigurasjoner.
    `,
    cookie_consent_text: "Vi bruker grunnleggende informasjonskapsler for å sikre at nettstedet fungerer som det skal, for eksempel å holde økten aktiv, lagre språkpreferansene dine og andre tilpassede konfigurasjoner.",
    read_policy: "Les retningslinjer for informasjonskapsler",
    support_title: "Kontakt kundestøtte",
    support_subject_label: "Tema",
    support_message_label: "Beskjed",
    support_submit_button: "Send melding",
    support_hint: "Merk: Dette vil åpne standard e-postapplikasjon for å sende meldingen.",
    support_success_msg: "Åpner e-postappen din ...",
    support_error_msg: "Kunne ikke sende melding. Vennligst prøv igjen senere.",
    explorer_title: "Utforsker",
    history_title: "Historie",
    animation_title: "Animasjon",
    config_title: "Konfigurasjon",
    tool_mouse: "Velg (Ctrl+M)",
    tool_brush: "Pensel (Ctrl+B)",
    tool_brush_mode: "Vekslemodus (solid/klar)",
    tool_eraser: "Viskelær (Ctrl+E)",
    tool_brush_size: "Juster børstestørrelsen",
    tool_bucket: "Fyll (Ctrl+F)",
    tool_eyedropper: "Pipette",
    tool_grid: "Rutenett (Ctrl+Shift+B)",
    tool_rotate: "Roter (Ctrl+Shift+R)",
    tool_flip_h: "Vend H (Ctrl+Shift+H)",
    tool_flip_v: "Vend V (Ctrl+Shift+V)",
    tool_transpose: "Transponer (Ctrl+Shift+T)",
    label_width: "Bredde",
    label_height: "Høyde",
    label_frames: "Antall rammer",
    label_animation: "Animasjonsstil",
    label_background_color: "Bakgrunnsfarge",
    label_interval: "Intervall",
    tool_anim_config: "Animasjonskonfigurasjon",
    label_new_width: "Ny bredde",
    label_new_height: "Ny høyde",
    label_apply: "Søke",
    label_colors: "Farger",
    label_size: "Størrelse",
    label_tolerance: "Toleranse",
    val_horizontal: "Horisontal",
    val_vertical: "Vertikal",
    val_sequence: "Sekvens",
    val_bounce: "Sprette",
    val_random: "Tilfeldig",
    val_solid: "Fast",
    val_clear: "Klar",
    action_add_sheet: "Nytt ark",
    action_import: "Import",
    action_export: "Eksport",
    action_sort_projects: "Sortere",
    sort_date_old: "Eldste først",
    sort_date_new: "Nyeste først",
    sort_name_az: "Navn (A-Å)",
    sort_name_za: "Navn (Z-A)",
    action_new_sprite: "Ny Sprite",
    action_new_project: "Nytt prosjekt",
    modal_save_all_title: "Lagre alle endringer",
    modal_save_all_desc: "Velg eiendelene du vil lagre:",
    modal_save_selected: "Lagre valgt",
    action_saved: "Lagret",
    modal_create_sprite_title: "Lag ny Sprite",
    modal_create_project_title: "Opprett nytt prosjekt",
    modal_add_sheet_title: "Legg til nytt ark",
    modal_rename_sheet_title: "Gi nytt navn til ark",
    modal_rename_sprite_title: "Gi nytt navn til Sprite",
    modal_delete_sprite_title: "Slett Sprite",
    modal_delete_project_title: "Slett prosjekt",
    modal_delete_sheet_title: "Slett ark",
    placeholder_sprite_name: "Navn",
    placeholder_project_name: "Navn",
    placeholder_sheet_name: "Navn",
    placeholder_new_name: "Nytt navn",
    action_create: "Skape",
    action_add: "Legge til",
    action_rename: "Gi nytt navn",
    action_duplicate: "Kopiere",
    action_delete: "Slett",
    action_cancel: "Kansellere",
    confirm_delete_sprite: "Er du sikker på at du vil slette denne spriten?",
    confirm_delete_project: "Er du sikker på at du vil slette dette prosjektet? Alle sprites vil bli fjernet.",
    confirm_delete_sheet: "Er du sikker på at du vil slette dette arket?",
    err_select_sprite: "Velg en sprite først.",
    err_select_project: "Velg et prosjekt først.",
    err_name_empty: "Navn kan ikke være tomt.",
    err_sprite_exists: "En sprite med det navnet finnes allerede.",
    err_project_exists: "Et prosjekt med det navnet eksisterer allerede.",
    err_no_content: "Ikke noe innhold å lagre.",
    err_no_changes: "Ingen endringer å lagre.",
    err_delete_last_sheet: "Kan ikke slette det siste arket.",
    err_extract_frames: "Kunne ikke trekke ut noen rammer.",
    err_indexeddb: "Kunne ikke lagre lokalt. Nettleseren din støtter kanskje ikke IndexedDB.",
    msg_upload_success: "Opplasting vellykket: {0}",
    msg_upload_failed: "Opplasting mislyktes: {0}",
    msg_save_success: "Lagring vellykket.",
    msg_saving: "Lagrer...",
    msg_multi_save_result: "Lagrede {0} ressurser. {1} feil.",
    menu_title: "Meny",
    menu_save: "Spare",
    menu_save_all: "Lagre alle",
    menu_support: "Kontakt kundestøtte",
    label_local_storage: "Lokal lagring",
    label_sign_in: "Logg på",
    modal_export_title: "Eksporter Sprite",
    label_filename: "Filnavn",
    label_format: "Format",
    action_export_confirm: "Eksport",
};

export default translations;
